import styled, { css } from "styled-components";
import Scrollbars from "react-custom-scrollbars";

export const Container = styled.div`
    position: absolute;
    width: ${({size}) => size.width};
    height: ${({size}) => size.height};
    
    ${({size}) => size.right && css`
        right: 0;
    `};
    display: flex;
    opacity:  ${({showFilter}) => showFilter ? '1': '0'};
    z-index:  ${({showFilter}) => showFilter ? '99': '-1'};
    flex-direction: column;
    max-height: 60vh;
    background-color: ${({theme}) => theme.container.secondary.background};
    margin-top: 39px;
    box-shadow: ${({theme}) => theme.container.secondary.boxShadow};
    border-radius: ${({theme}) => theme.container.secondary.borderRadius};
    padding: 16px;
    
    .header {
        display: flex;
        justify-content: space-between;
        width: 100%;
        align-items: center;
        margin: 0 0 10px;

        svg {
            width: 10px;
            cursor: pointer;
            color: ${({theme}) => theme.container.secondary.text};
        }
        h4 {
            color: ${({theme}) => theme.primary};
        }
    }
    .main {
        display: flex;
        height: fit-content;
        flex-direction: column;
        color: ${({theme}) => theme.container.secondary.text};

        >div:not(:first-child) {
            margin-top: 16px;
        }
        >button {
            align-self: flex-end;
            margin-top: 1rem;
        }
    } 
    h5 {
        font-weight: normal;
        font-size: 14px;
        justify-content: space-between;
        display: flex;
        margin-bottom: 8px;
        >button {
            padding: 0;
            font-size: .75rem;
            background-color: transparent;
            border: 0;
            color: inherit;
            font-weight: normal;
            text-transform: none;
            &:focus {
                outline: none;
            }
            .checkbox {
                padding: 0;
                margin-right: .25rem;
                transform: scale(.75);
            }    
         }
    }
    
    .badge {
        background: transparent;
        color: transparent;
        &.content{
            background: ${props => props.theme.title};
            color: ${props => props.theme.bg};
            min-width: fit-content;
            padding: .4rem;
            border-radius: 20px;
        }
    }
    /*.select-operator {
        width: 100%;
        margin-top: .3rem;
        &_container{
          > div {
            display: flex;
            flex-wrap: wrap;
            padding: -5px;
            > div{
                background-color: ${({theme}) => theme.secondary};
                color: ${({theme}) => theme.bg};
                border-radius: 5px;
                margin: 5px;
            }
          }
        }
    }
    >.dept {
        margin-top: 0;
    }
    > div {
        margin-top: .4rem;
            p {
                display: flex;
                justify-content: space-between;
                align-items: center;
                >button {
                padding: 0;
                font-size: .75rem;
                background-color: transparent;
                border: 0;
                font-weight: normal;
                text-transform: none;
                &:focus {
                    outline: none;
                }
                .checkbox {
                    padding: 0;
                    margin-right: .25rem;
                    transform: scale(.75);
                }    
                }
            }
        }*/
`
export const Scrollbar = styled(Scrollbars)`
    margin-top: 12px;
    width: calc(100% + 1rem)!important;
    > div {
        &:first-child{
            background-color: transparent;
            padding-right: 1rem;
        }
        &:nth-child(3){
            &:not(.bar) {
                width: 7px!important;
                right: 4px!important;
            }
            &:nth-child(2) {
                background-color: red!important;
            }
            > div {
                background-color: red!important;
                opacity: .8;
            }
        }
    }`